import { connect } from 'pwa-helpers';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { StoreState } from '../../../store/store.interface';
import { UserProfile } from '../../user-profile/user-profile.interface';
import { selectUser } from '../../user-profile/user-profile.selectors';
import { MessageType } from '../../alert/global-message.interface';
import { AlertSize } from '../../alert/alert';
import { FA4_SUBSCRIPTION_BANNER_TEXT, loading } from '../../../common/constants/api-constants';
import { fetchUserProfile } from '../../user-profile/user-profile.thunks';
import { ActionStatus } from '../../../common/constants/action-status';

@customElement('mhecomm-fa4-subscription-banner')
export class FA4SubscriptionBanner extends connect(store)(BaseComponent) {

  @state()
  user?: UserProfile;

  @state()
  private loading = true;

  async connectedCallback() {
    super.connectedCallback();
    store.dispatch(fetchUserProfile());
  }

  stateChanged(state: StoreState) {
    const userProfileResponse = state.userProfileState.userProfileResponse;
    if ([ActionStatus.succeeded, ActionStatus.failed].includes(userProfileResponse.status)) {
      this.loading = false;
    }
    this.user = selectUser(state);
  }

  renderComp() {
    const params = new URLSearchParams(window.location.search);
    return html`
      ${this.loading
        ? this.renderLoadingTemplate()
        : this.user && params.get('flow')?.toLowerCase() === 'fa4'
          ? this.renderSubscriptionBanner()
          : nothing
      }
    `;
  }

  renderLoadingTemplate() {
    return html`
      <span class="visually-hidden">Loading fa4 subscription banner</span>
      ${loading({ columns: 1, m: 'mt-2' })}
    `;
  }

  renderSubscriptionBanner() {
    return html`
      <div class="mt-2">
        <mhecomm-alert
          .type=${MessageType.info}
          .message=${this.getFa4ActiveUserSubscriptionTemplate()}
          .size=${AlertSize.small}
        ></mhecomm-alert>
      </div>
    `;
  }

  getFa4ActiveUserSubscriptionTemplate() {
    return FA4_SUBSCRIPTION_BANNER_TEXT(this.user?.givenName!);
  }

}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-fa4-subscription-banner': FA4SubscriptionBanner;
  }
}